import request from '@/utils/request'

export function login(data) {
  return request({
    url: '/user/login',
    method: 'post',
    data
  })
}
export function regUser(data) {
  return request({
    url: '/user/regUser',
    method: 'post',
    data
  })
}
export function checkUser(data) {
  return request({
    url: '/user/checkUser',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: { token }
  })
}
export function getUserInfo(data) {
  return request({
    url: '/user/getUserInfo',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}
